import { Injectable } from '@angular/core';
import { StockCustomItem } from '../models/stock';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
  
  export class StockCustomService {
  
  apiUrl = 'v1/stock-custom';

  constructor(private http: HttpClient) {
  
  }

  public getStockCustom() {
    return this.http.get<StockCustomItem[]>(environment.apiUrl + `${this.apiUrl}`);
  }

  public saveStockCustom(item: StockCustomItem) {
    return this.http.post<StockCustomItem>(environment.apiUrl + `${this.apiUrl}/${item.stockCustomId}`, item);
  }

  public deleteStockCustom(stockCustomId: number) {
    return this.http.delete<void>(environment.apiUrl + `${this.apiUrl}/${stockCustomId}`);
  }

}